import React from 'react';
import PromoBannerEditor from '../../components/PromoBannerEditor';

/**
 * Promo banner admin page. Wraps the existing PromoBannerEditor on its own
 * URL (`/admin/promo-banner`) instead of being a tab inside the monolith.
 *
 * The editor still writes to publicSiteContent/promoBanner — announcements
 * are a separate, layered system that can override the promo banner via
 * <TopBanner /> when an admin enables one.
 */
export default function PromoBannerAdmin() {
  return <PromoBannerEditor />;
}
